import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setActiveFeaturedSelection } from '../modules/active_featured_selection';
import { navigate } from '../modules/high_level_actions';
import { openFeaturedSelectionsModal } from '../modules/active_modal';

class NegliteCommerceBar extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        // Define Featured Selection items.
        let aFeaturedSelections = this.props.featured.map(oProduct => {
            const hoverClass  = this.props.navigable ? "" : "shiny-hover ";
            const activeClass = parseInt( this.props.activeProduct.id, 10 ) === parseInt( oProduct.id, 10 ) ? "active" : "";
        let oEvent = {
            preventDefault: () => {/* noop */},
            currentTarget: {
                pathname: '/catalog/product/' + oProduct.id + '-' + oProduct.url
            }
        }

            return (
                <li
                    key       = {oProduct.id}
                    className = { hoverClass + activeClass}
                    onClick   = {() => this.props.dispatch( [setActiveFeaturedSelection( oProduct), openFeaturedSelectionsModal(), navigate(oEvent, false)] )}
                >
                    <div className = "product-scaled-wrapper">
                        <img
                            className = "product-scaled"
                            src       = {'//s3.amazonaws.com/bookspan-media/covers/full/' + oProduct.mmid + '.jpg'}
                        />
                    </div>
                </li>
            );
        });

        // Set conditional CSS classNames and display text
        //@TODO condense all the checks for which section is active!!!
        let sFeaturedHeaderTxt = 'Featured Selections';
        let sFeaturedActive    = (this.props.path === '/' ? 'active' : '');
        let nCartSubTotal      = this.props.computedCart.subtotal;
        let sButtonText        = 'Checkout';

        return (
        <div className={"half-col left " + sFeaturedActive}>
            <div className="inner-wrapper right">
                <h6 className = {"header-link " + sFeaturedActive} >
                    {sFeaturedHeaderTxt}
                </h6>
                <div className="feature-selections-wrapper">
                    <ul>
                        {aFeaturedSelections}
                    </ul>
                </div>
            </div>
        </div>);
    }
}


function mapStateToProps(state){
    return {
        'featured': state.featured,
        'activeProduct': state.activeProduct,
        'path': state.path
    };
}

export default connect(mapStateToProps)(NegliteCommerceBar);


// WEBPACK FOOTER //
// ./src/components/NegLiteCommerceBar.jsx